import { render, staticRenderFns } from "./language-dropdown.vue?vue&type=template&id=458251d5&scoped=true"
import script from "./language-dropdown.vue?vue&type=script&lang=js"
export * from "./language-dropdown.vue?vue&type=script&lang=js"
import style0 from "./language-dropdown.vue?vue&type=style&index=0&id=458251d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_css-loader@6.11.0_webpack@5.107.2_postcss@8_cd0c78093fd3e0fe2601f4284460232b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458251d5",
  null
  
)

export default component.exports